// Enumeración para nombrar los tipos de personas posibles

export const personTypeEnum = {
  'PEDIATRIC': 'Paciente pediatría',
  'PREGNANT': 'Paciente obstetricia',
  'FAMILY': 'Familiar',
  'OTHER': 'Otro'
}
